module.exports = __webpack_public_path__ + "img/pp8.a1fa09d2.png";